function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  vertical-align: top;\n  min-height: 24px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: ", ";\n  border-radius: 2px;\n  border-width: 1px;\n  border-style: solid;\n  color: ", ";\n\n  ", " ", ";\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    border-color: ", ";\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    line-height: ", ";\n    \n    & > svg {\n      width: 14px;\n      height: 14px;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n\n    & > svg {\n      width: 12px;\n      height: 12px;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { themeGet, space, fontSize } from 'styled-system';
import { applySizes, applyVariations, getPaletteColor, getTextColorOn, deprecatedColorValue, deprecatedPropType } from '../utils';
var sizes = {
  small: css(_templateObject(), themeGet('textStyles.small')),
  medium: css(_templateObject2(), themeGet('textStyles.display0'), themeGet('lineHeights.standard'))
};
var variations = {
  outline: css(_templateObject3(), getPaletteColor('base'), function (props) {
    return getPaletteColor(props.borderColor, 'base')(props);
  }, function (props) {
    return props.bg ? "background-color: ".concat(getPaletteColor(props.bg, 'base')(props), ";") : '';
  }),
  fill: css(_templateObject4(), getTextColorOn('base'), getPaletteColor('base'), getPaletteColor('base')),
  // todo: remove this copy of the fill variation in v4 as its name does not follow conventions
  solid: css(_templateObject5(), getTextColorOn('base'), getPaletteColor('base'), getPaletteColor('base'))
};
var Stamp = styled.div(_templateObject6(), themeGet('letterSpacings.caps'), getPaletteColor('base'), space, fontSize, applySizes(sizes), applyVariations('Stamp', variations));
Stamp.displayName = 'Stamp';
Stamp.propTypes = _objectSpread(_objectSpread(_objectSpread({}, space.propTypes), fontSize.propTypes), {}, {
  size: PropTypes.oneOf(Object.keys(sizes)),
  variation: PropTypes.oneOf(Object.keys(variations)),
  color: deprecatedColorValue(),
  bg: deprecatedPropType('color'),
  borderColor: deprecatedColorValue()
});
Stamp.defaultProps = {
  px: 1,
  py: 0,
  color: 'border.light',
  bg: 'background.light',
  borderColor: 'border.base',
  size: 'medium',
  variation: 'outline'
};
export default Stamp;